import React from 'react';
import { Outlet } from 'react-router-dom';


function PublicRoute({ component: Component, ...rest }) {

  return  <Outlet />;
}

export default PublicRoute;